import React, { useContext } from 'react'
import { ManageEmployeeContext} from '../../../components/employeeData/ManageEmployeesPage'


const PopOver = (visible = '', width = '200px') => {
  const  data = useContext(ManageEmployeeContext)
  let handler1 = data[0]
  let handler2 = data[1]
  let status = data[2] 
  return (
          <div
          className={`absolute  overflow-y-auto  ${visible ? '' : 'hidden'} mt-5 -ml-24`}
          aria-labelledby='modal-title'  
          aria-modal='true'
        >
          <div className='flex items-end justify-center inset-0 text-center sm:block sm:p-0'>
            <div
              className='fixed inset-0'
              aria-hidden='true'
              onClick={() => handler1()}
            >
            </div>
            <div className='inline-block bg-white normal-case rounded-ds-md text-left overflow-hidden shadow-ds-xl transform transition-all duration-300 ease-[cubic-bezier(.22,1,.36,1)]'
            style={{zIndex : 1000, width : width}}
            >
              <div className="bg-white pl-5 pb-4 border pt-4 pr-14 2xl:p-3 2xl:pr-16 sm:pb-4">  
                <div className=" sm:flex sm:items-start flex flex-col">
                  <div className=' flex items-center'>
                    <input type="checkbox"  value='Active' name='customer_status' className='h-5 w-5 ml-1 bg-white rounded-ds-sm border-gray-300 text-blue-600 focus:ring-0 focus:ring-offset-0  cursor-pointer'
                      onChange={(e) => handler2(e.target , 'Active')} 
                      checked={status === 'Active' }
                    />
                    <label htmlFor='Active' className='leading-3 text-xs text-gray-600 ml-4'>Active</label>
                  </div>
                  <div className='mt-7 flex items-center'>
                    <input type="checkbox"  value='Inactive' name='customer_status' className='h-5 w-5 ml-1 bg-white rounded-ds-sm border-gray-300 text-blue-600 focus:ring-0 focus:ring-offset-0  cursor-pointer'
                     checked={status === 'Inactive'}
                     onChange={(e) => handler2(e.target, 'Inactive')}
                    />
                    <label htmlFor='Inactive' className='leading-3 text-xs text-gray-600 ml-4'>Inactive</label>
                  </div>
                </div>
              </div>
              <div className="h-12 grid grid-col-1 place-content-center bg-ds-brand-100">
                <button 
                  type='button'
                  className='font-semibold text-base text-blue-600 cursor-pointer leading-4' 
                  onClick={(e) => handler2(e.target , 'clear')} 
                >
                  Clear filter
                </button>
              </div>
            </div>
          </div>
        </div>   
  )
}

export default PopOver